import { Component, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { SneAnswerService } from 'src/app/services/sne-answer.service';
import { APP_COLORS } from 'src/global-styles';
import { SneOralCommunicationBase } from '../sne-oral-communcation.base';
import { HEADER_STATES } from '../../../shared/header/header.helper';
import { SneVideoComponent } from '../../components/sne-video/sne-video.component';

@Component({
  selector: 'ets-oc-interstitial',
  templateUrl: './oc-interstitial.component.html',
  styleUrls: ['./oc-interstitial.component.scss']
})
export class OcInterstitialComponent extends SneOralCommunicationBase implements OnInit {
  @ViewChild(SneVideoComponent) videoComp!:SneVideoComponent;

  constructor(route: ActivatedRoute, router: Router, sneAnswerService: SneAnswerService) {
    super(route, router, sneAnswerService);
  }

  headerState = HEADER_STATES.BACK;
  APP_COLORS = APP_COLORS;
  endInterstitial = false;

  ngOnInit() {
    // Get the route params to determine if it's the end interstitial
    this.route.params.subscribe(params => {
      const { questionNum, section } = params;
      this.endInterstitial = questionNum === 'end';
    });
    this.processParams();
  }

  closeModal(){
    if(this.videoComp){
      this.videoComp.onModalClose();
    }
    this.closeModalAndNav();
  }
}
